module.exports = __webpack_public_path__ + "img/users.0bc902bb.svg";